import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ContactsFilledSvg from "@ant-design/icons-svg/es/asn/ContactsFilled";
import AntdIcon from "../components/AntdIcon";
var ContactsFilled = function ContactsFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ContactsFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ContactsFilled.displayName = 'ContactsFilled';
}
export default /*#__PURE__*/React.forwardRef(ContactsFilled);